import Serializer from 'umg-ember-backend/serializers/application';

export default class ArticleSerializer extends Serializer {
  attrs = {
    variantChannel: 'vChannelId',
    ownedByChannel: 'ownedByChannelId',
  };
}
